import { Injectable, Component } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CurrentUser } from './currentUser.service';
import { environment } from 'environments/environment';
import { FirebaseService } from './firebase.service';
import { FacebookService } from './facebook.service';

@Injectable()
export class CanActivateLogin implements CanActivate {
  constructor(private router: Router, private currentUser: CurrentUser,
    private firebaseService: FirebaseService, private facebookService: FacebookService) {}

  public canActivate(activatedRouter: ActivatedRouteSnapshot): boolean {
    if (this.currentUser.getJwtToken()) {
      if (activatedRouter.queryParamMap.get('contrib')) {
        if (this.currentUser.get() ? !(this.currentUser.get().guest && activatedRouter.queryParamMap.get('signUp')) : false) {
          this.firebaseService.logEvent('logout');
          this.firebaseService.setUserId('');
          this.currentUser.clear();
          this.facebookService.clearUserId();
          this.router.navigate(['/account/login'], {queryParams: {contrib: activatedRouter.queryParamMap.get('contrib')}});
        }
      }
      if (activatedRouter.queryParamMap.get('next')) {
        const redirectionLink = activatedRouter.queryParamMap.get('next');
        window.location.href = this.currentUser.authenticateUrl(redirectionLink);
      } else if
       ( activatedRouter.queryParamMap.get('contrib')) {
        return true;
      } else {
        this.router.navigate(['/stories']);
        return false;
      }
      return false;
    }
    return true;
  }
}
